import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ApiResourceLocation, ResponseResult } from '@softline/core';
import { Kopfau, PmsTaetigkeit } from '../types/kopfau';
import { SOFTLINE_API_TIME_REPORT_START_STOP } from '../goldschmiede.api';

@Injectable()
export class TimeReportService {
  readonly #api = inject(ApiDataAccess);

  async start(orders: Kopfau[], taetigkeit?: PmsTaetigkeit): Promise<any> {
    const location: ApiResourceLocation = {
      path: `${SOFTLINE_API_TIME_REPORT_START_STOP}/start`,
    };

    const payload = orders.map((order) => ({
      object: { id: order.objekt.id },
      pmstaet: taetigkeit?.pmstaet,
    }));

    const response = await this.#api.create<any, ResponseResult<any>>(location, payload);
    return response.result;
  }

  async stop(orders: Kopfau[]): Promise<any> {
    const location: ApiResourceLocation = {
      path: `${SOFTLINE_API_TIME_REPORT_START_STOP}/stop`,
    };
    const payload = orders.map((o) => ({ object: o.objekt }));
    const response = await this.#api.create<any, ResponseResult<any>>(location, payload);
    return response.result;
  }
}
